import { useSelector } from "@/core/redux/store";
import { useMemo } from "react";

export type EmptyStateVariant =
  | "noSpecifications"
  | "noResponses"
  | "filter"
  | "search";

type Params = {
  search?: string;
  status: string[];
};

export function useEmptyStateVariant({
  search,
  status,
}: Params): EmptyStateVariant {
  const hasSpecification = useSelector((state) => state.user.hasSpecification);
  return useMemo(() => {
    const trimmedSearch = search?.trim() ?? "";
    const hasSearch = trimmedSearch !== "";
    const hasActiveFilters = status.length > 0;

    if (hasSearch) return "search";
    if (hasActiveFilters) return "filter";
    if (!hasSpecification) return "noSpecifications";
    return "noResponses";
  }, [search, status, hasSpecification]);
}
